<template>
  <!-- PC：居中弹窗 -->
  <Modal
    v-if="isPC"
    :show="show"
    :closable="true"
    content-width="700px"
    @update:show="emit('update:show', $event)"
    @close="emit('update:show', false)"
  >
    <ClosePriceForm
      :current-price="currentPrice"
      :default-value="defaultValue"
      :precision="precision"
      :min="min"
      :max="max"
      :target-date="targetDate"
      @submit="handleSubmit"
    />
  </Modal>

  <!-- H5：底部上拉弹窗 -->
  <Popup
    v-else
    :visible="visible"
    position="bottom"
    round
    size="auto"
    @update:visible="visible = $event"
  >
    <div class="px-[28px] pt-[40px] pb-[64px]">
      <ClosePriceForm
        :current-price="currentPrice"
        :default-value="defaultValue"
        :precision="precision"
        :min="min"
        :max="max"
        :target-date="targetDate"
        @submit="handleSubmit"
      />
    </div>
  </Popup>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { useFegoPageInfo } from '@ark/web-shared/use';
import Popup from '@futuweb/future-ui/es/popup';
import '@futuweb/future-ui/es/popup/style/css';
import Modal from './modal.vue';
import ClosePriceForm from './close-price-form.vue';
const __sfc_main = {};
__sfc_main.props = {
  show: {
    key: "show",
    required: true,
    type: Boolean
  },
  currentPrice: {
    key: "currentPrice",
    required: true,
    type: String
  },
  defaultValue: {
    key: "defaultValue",
    required: false,
    type: [String, null]
  },
  precision: {
    key: "precision",
    required: false,
    type: Number
  },
  min: {
    key: "min",
    required: false,
    type: Number
  },
  max: {
    key: "max",
    required: false,
    type: Number
  },
  targetDate: {
    key: "targetDate",
    required: false,
    type: [String, null]
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    isPC
  } = useFegoPageInfo();
  const visible = computed({
    get: () => props.show,
    set: (val: boolean) => emit('update:show', val)
  });
  function handleSubmit(value: string) {
    emit('submit', value);
  }
  return {
    emit,
    isPC,
    visible,
    handleSubmit
  };
};
__sfc_main.components = Object.assign({
  Modal,
  ClosePriceForm,
  Popup
}, __sfc_main.components);
export default __sfc_main;
</script>
